import { useTranslation } from 'react-i18next';

import type { ImportKind } from '@nucleus-commerce/api-client/admin';

import { ATTRIBUTE_COLUMN_PREFIX, COLUMN_GUIDES, WEIGHT_UNIT_CODES } from '../schemas/column-guide';

export function ColumnGuideList({ kind }: { kind: ImportKind }) {
  const { t } = useTranslation('importsExports');
  const guide = COLUMN_GUIDES[kind];
  const code = 'bg-muted rounded px-1 py-0.5 font-mono text-[11px]';

  return (
    <div className="text-muted-foreground flex flex-col gap-2 text-xs">
      <p>
        <span className="text-foreground font-medium">{t('guide.required')}</span>{' '}
        {guide.required.map((group, i) => (
          <span key={group.join()}>
            {i > 0 ? ', ' : null}
            {group.map((name, j) => (
              <span key={name}>
                {j > 0 ? ` ${t('guide.or')} ` : null}
                <code className={code}>{name}</code>
              </span>
            ))}
          </span>
        ))}
      </p>
      <p className="leading-5">
        <span className="text-foreground font-medium">{t('guide.optional')}</span>{' '}
        {guide.optional.map((name, i) => (
          <span key={name}>
            {i > 0 ? ' ' : null}
            <code className={code}>{name}</code>
          </span>
        ))}
      </p>
      {guide.attributeColumns ? (
        <p className="leading-5">
          <code className={code}>{`${ATTRIBUTE_COLUMN_PREFIX}<key>`}</code>{' '}
          {t('guide.attributeColumns')}
        </p>
      ) : null}
      {guide.weightUnits ? (
        <p className="leading-5" data-testid="weight-units">
          {t('guide.weightUnits', { units: WEIGHT_UNIT_CODES })}
        </p>
      ) : null}
    </div>
  );
}
